import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Button } from "@zillow/constellation-10";
import { yieldCallback } from "@zillow/yield-callback";
import { motion } from "framer-motion";
import HtmlToReact, { Parser } from "html-to-react";
import React from "react";
const htmlToReactParser = new Parser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const underlineClass = css({
  // v8 colors.brand (#0041D9 / legacy #006AFF).
  backgroundColor: "bg.accent.brand.hero",
  height: "3px",
  borderRadius: "3px",
  width: "100%",
  position: "absolute",
  bottom: "0"
});
const UNDERLINE_TRANSITION = {
  layout: {
    duration: 0.2,
    ease: "easeOut"
  }
};
const CarouselTab = ({
  isActive,
  onClick,
  children
}) => {
  const processingInstructions = [{
    shouldProcessNode() {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }];
  const parsedChildren = htmlToReactParser.parseWithInstructions(children, () => true, processingInstructions);
  return (
    // v10 Button has no `bare` emphasis, so the outlined brand Button is
    // stripped back to v8's bare look: no fill, and the v10 border (an inset
    // box-shadow) coloured transparent, which keeps the focus-visible ring.
    // v8's box model is restored too — a 1px transparent border plus 9px
    // vertical padding — so the tab is 44px tall like v8 (v10 md is 48px on
    // the zillow theme) and the underline sits inside the border as before.
    /* @__PURE__ */ jsxs(Button.Root, { tone: "brand", emphasis: "outlined", size: "md", onClick: yieldCallback(() => onClick()), css: {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "transparent",
      paddingBlock: "9px",
      backgroundColor: {
        base: "transparent",
        _hover: "transparent",
        _active: "transparent"
      },
      boxShadowColor: {
        base: "transparent",
        _hover: "transparent",
        _active: "transparent"
      }
    }, children: [
      /* @__PURE__ */ jsx(Button.Label, { css: isActive ? {
        // v8 kept the active tab brand-blue on hover and press.
        color: {
          base: "text.action.hero.default",
          _groupHover: "text.action.hero.default",
          _groupActive: "text.action.hero.default"
        }
      } : {
        // v8 colors.linkActive, the bare Button hover, and
        // back to linkActive while pressed.
        color: {
          base: "text.action.strong.hover",
          _groupHover: "text.action.hero.hover",
          _groupActive: "text.action.strong.hover"
        }
      }, children: parsedChildren }),
      isActive && /* @__PURE__ */ jsx(motion.div, { className: underlineClass, layout: true, transition: UNDERLINE_TRANSITION, layoutId: "underline" })
    ] })
  );
};
export {
  CarouselTab as default
};
